import '../styles/globals.css'
import type { AppProps } from 'next/app';
import Layout from '../components/layout'
import { ParallaxProvider } from 'react-scroll-parallax';
import { useEffect } from 'react';

// Suppress specific React warnings in development
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Filter out specific warnings
    if (typeof args[0] === 'string') {
      // FontAwesome defaultProps warning
      if (args[0].includes('Warning: FontAwesomeIcon: Support for defaultProps will be removed')) {
        return;
      }
      // crossOrigin warning (as a backup)
      if (args[0].includes('Warning: Received `true` for a non-boolean attribute `crossOrigin`')) {
        return;
      }
    }
    originalConsoleError(...args);
  };
}

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ParallaxProvider>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </ParallaxProvider>
  )
}

export default MyApp
